import { Column, Row } from 'src/shared/components/Semantic/all'
import { useLocalization } from 'src/shared/hooks/useLocalization'
import type { Quote_ } from 'src/api/db/apiQuote'
import { getBillingDocumentData } from '../utils'
import { DocumentField } from './DocumentField'

export const InvoicePaymentDetails = ({ quote }: { quote: Quote_ }) => {
  const { t } = useLocalization()
  const invoice = getBillingDocumentData(quote)

  return (
    <Column className="gap-3 rounded-card border border-border bg-muted/30 px-4 py-3.5">
      <span className="text-xs uppercase tracking-wide text-muted-foreground">
        {t('Payment details', 'Betalningsuppgifter')}
        {invoice.isDraftPreview && (
          <span className="ml-2 normal-case">
            ({t('Preview', 'Förhandsvisning')})
          </span>
        )}
      </span>

      <Row className="flex-wrap gap-x-12 gap-y-4">
        {invoice.bankgiro && (
          <DocumentField
            label={t('Bankgiro', 'Bankgiro')}
            value={invoice.bankgiro}
          />
        )}
        {invoice.plusgiro && (
          <DocumentField
            label={t('Plusgiro', 'Plusgiro')}
            value={invoice.plusgiro}
          />
        )}
        {invoice.iban && <DocumentField label="IBAN" value={invoice.iban} />}
        {invoice.bic && <DocumentField label="BIC" value={invoice.bic} />}
        <DocumentField
          label={t('Payment terms', 'Betalningsvillkor')}
          value={t(
            `${invoice.paymentTermsDays} days net`,
            `${invoice.paymentTermsDays} dagar netto`
          )}
        />
        <DocumentField
          label={t('Payment reference', 'Betalreferens')}
          value={invoice.paymentReference || '—'}
        />
      </Row>

      {invoice.reverseCharge && (
        <p className="text-xs text-muted-foreground">
          {t(
            'Reverse charge — VAT to be accounted for by the buyer.',
            'Omvänd betalningsskyldighet — moms redovisas av köparen.'
          )}
        </p>
      )}

      {!invoice.reverseCharge && (
        <p className="text-xs text-muted-foreground">
          {t(
            `Line items are exclusive of VAT. VAT rate ${invoice.vatRate}%.`,
            `Radbelopp är exklusive moms. Momssats ${invoice.vatRate}%.`
          )}
        </p>
      )}

      {invoice.notes && (
        <p className="text-sm text-foreground whitespace-pre-wrap">
          {invoice.notes}
        </p>
      )}
    </Column>
  )
}
